import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.array.sort";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "C:\\Users\\frontend\\Desktop\\Piaf-Vue 2\\Piaf-Vue\\node_modules\\@babel\\runtime-corejs3/helpers/esm/toConsumableArray";
import _defineProperty from "C:\\Users\\frontend\\Desktop\\Piaf-Vue 2\\Piaf-Vue\\node_modules\\@babel\\runtime-corejs3/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapMutations, mapActions } from 'vuex';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import TodoListItem from "../../../components/TodoApp/TodoListItem";
import ApplicationMenu from "../../../components/Common/ApplicationMenu";
export default {
  components: {
    'v-select': vSelect,
    'todo-list-item': TodoListItem,
    'application-menu': ApplicationMenu
  },
  data: function data() {
    return {
      sort: {
        column: 'title',
        label: 'Title'
      },
      sortOptions: [{
        column: 'title',
        label: 'Title'
      }, {
        column: 'category',
        label: 'Category'
      }, {
        column: 'label',
        label: 'Label'
      }, {
        column: 'status',
        label: 'Status'
      }],
      search: '',
      selectedItems: [],
      categories: [{
        label: 'Flexbox',
        value: 'Flexbox'
      }, {
        label: 'Sass',
        value: 'Sass'
      }, {
        label: 'Vue',
        value: 'Vue'
      }, {
        label: 'React',
        value: 'React'
      }],
      labels: [{
        label: 'EDUCATION',
        value: 'EDUCATION',
        color: 'secondary'
      }, {
        label: 'NEW FRAMEWORK',
        value: 'NEW FRAMEWORK',
        color: 'primary'
      }, {
        label: 'PERSONAL',
        value: 'PERSONAL',
        color: 'info'
      }],
      statuses: [{
        text: 'PENDING',
        value: 'PENDING'
      }, {
        text: 'COMPLETED',
        value: 'COMPLETED'
      }],
      newItem: {
        title: '',
        category: '',
        detail: '',
        label: '',
        status: ''
      }
    };
  },
  computed: _objectSpread({}, mapGetters(['isLoad', 'items', 'todoError'])),
  methods: _objectSpread({}, mapActions(['getTodoItems']), {}, mapMutations(['addTodoItem']), {
    isSelectedAll: function isSelectedAll() {
      return this.selectedItems.length >= this.items.length;
    },
    isAnyItemSelected: function isAnyItemSelected() {
      return this.selectedItems.length > 0 && this.selectedItems.length < this.items.length;
    },
    hideModal: function hideModal(refname) {
      this.$refs[refname].hide();
    },
    changeOrderBy: function changeOrderBy(sort) {
      this.sort = sort;
    },
    addNewItem: function addNewItem() {
      var date = new Date();
      this.addTodoItem({
        title: this.newItem.title,
        detail: this.newItem.detail,
        category: this.newItem.category.value,
        label: this.newItem.label.value,
        status: this.newItem.status,
        date: date.getDay() + '.' + date.getMonth() + 1 + '.' + date.getFullYear(),
        labelColor: this.newItem.label.color
      });
      this.newItem = {
        title: '',
        category: '',
        detail: '',
        label: '',
        status: ''
      };
      this.hideModal('modalright');
    },
    selectAll: function selectAll(isToggle) {
      if (this.selectedItems.length >= this.items.length) {
        if (isToggle) {
          this.selectedItems = [];
        }
      } else {
        this.selectedItems = this.items.map(function (x) {
          return x.id;
        });
      }
    },
    keymap: function keymap(event) {
      switch (event.srcKey) {
        case 'select':
          this.selectAll(false);
          break;

        case 'undo':
          this.selectedItems = [];
          break;
      }
    },
    getIndex: function getIndex(value, arr, prop) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] === value) {
          return i;
        }
      }

      return -1;
    },
    toggleItem: function toggleItem(event, itemId) {
      if (event.shiftKey && this.selectedItems.length > 0) {
        var _this$selectedItems;

        var itemsForToggle = this.items;
        var start = this.getIndex(itemId, itemsForToggle, 'id');
        var end = this.getIndex(this.selectedItems[this.selectedItems.length - 1], itemsForToggle, 'id');
        itemsForToggle = itemsForToggle.slice(Math.min(start, end), Math.max(start, end) + 1);

        (_this$selectedItems = this.selectedItems).push.apply(_this$selectedItems, _toConsumableArray(itemsForToggle.map(function (item) {
          return item.id;
        })));
      } else {
        if (this.selectedItems.includes(itemId)) {
          this.selectedItems = this.selectedItems.filter(function (x) {
            return x !== itemId;
          });
        } else {
          this.selectedItems.push(itemId);
        }
      }
    },
    handleContextmenu: function handleContextmenu(vnode) {
      if (!this.selectedItems.includes(vnode.key)) {
        this.selectedItems = [vnode.key];
      }
    },
    onContextCopy: function onContextCopy() {
      console.log('context menu item clicked - Copy Items: ', this.selectedItems);
    },
    onContextArchive: function onContextArchive() {
      console.log('context menu item clicked - Move to Archive Items: ', this.selectedItems);
    },
    onContextDelete: function onContextDelete() {
      console.log('context menu item clicked - Delete Items: ', this.selectedItems);
    }
  }),
  mounted: function mounted() {
    this.getTodoItems();
    document.body.classList.add("right-menu");
  },
  beforeDestroy: function beforeDestroy() {
    document.body.classList.remove("right-menu");
  }
};